import { Entity } from '@sketchpixy/rubix/lib/L20n';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, reset } from 'redux-form';
import CustomField from '../forms/Fields/CustomField.jsx';
import MDButton from '../MDButton/MDButton.jsx';
import IconButton from '@material-ui/core/IconButton';
import Refresh from '@material-ui/icons/Refresh';

@connect(state => ({}))
@reduxForm({ form: 'MksKeysSearchForm' })
class MksKeysHeader extends Component {

  onKeyFunctionChange(value) {
    const { onKeyFunctionChange } = this.props;
    if (onKeyFunctionChange) {
      onKeyFunctionChange(value);
    }
  }

  onDesignationChange(value) {
    const { onDesignationChange } = this.props;
    if (onDesignationChange) {
      onDesignationChange(value);
    }
  }

  onSearchReset() {
    const { dispatch, onSearchReset } = this.props;
    dispatch(reset('MksKeysSearchForm'));
    if (onSearchReset) {
      onSearchReset();
    }
  }

  render() {
    const {
      themeName,
      onRefresh,
      entitiesNumberSection,
      totalKeys,
    } = this.props;

    const themeClass = `list-view-header bg-${themeName}-theme`;
    
    return (
      <div className={themeClass} style={{ width: '100%' }}>
        <div style={{ minHeight: 70, padding: 0, display: 'flex', marginLeft: 0, alignItems: 'center' }}>
          {entitiesNumberSection}
          
          <Entity
            componentClass={Field}
            name="keyFunction"
            type="text"
            componentAttribute="placeholder"
            component={CustomField}
            className="form-control"
            entity="keyFunction"
            onHandleChange={value => this.onKeyFunctionChange(value)}
            containerStyle={{ marginRight: 10, minWidth: 200, marginBottom: -10 }}
          />

          <Entity
            componentClass={Field}
            name="designation"
            type="text"
            componentAttribute="placeholder"
            component={CustomField}
            className="form-control"
            entity="designation"
            onHandleChange={value => this.onDesignationChange(value)}
            containerStyle={{ marginRight: 10, minWidth: 250, marginBottom: -10 }}
          />

          <MDButton
            backgroundColor="#F44336"
            containerStyle={{ margin: 0, marginLeft: 10, marginTop: 0 }}
            title={<Entity entity="reset" />}
            onClick={() => this.onSearchReset()}
          />
        </div>
      </div>
    );
  }
}

export default MksKeysHeader;

